import {
  AiResponseReviewRating,
  SortAiResponseReviewColumnEnum,
  SortDirectionEnum, FilterBoolEnum
} from "@app/operations/ai-response-review/enums";

export interface PromptCategorySummaryResult {
  summary: string;
  generatedAt: string;
  rowCount: number;
}

export interface AiResponseReviewHealthMetrics {
  sqlWarningFreeRate: number;
  sqlWarningFreeRateTrend: 'up' | 'neutral' | 'down';
  responseSuccessRate: number;
  responseSuccessRateTrend: 'up' | 'neutral' | 'down';
}

export interface AiResponseReviewQueryModel {
  startDate?: Date;
  endDate?: Date;
  threadId?: string;
  clientId?: number;
  clientName?: string;
  projectId?: number;
  environment?: string;
  userId?: number;
  userName?: string;
  userRating?: AiResponseReviewRating;
  internalRating?: AiResponseReviewRating;
  minResponseTimeMs?: number;
  search?: string;
  devResolved?: FilterBoolEnum;
  tableGenerated?: FilterBoolEnum;
  tableDownloaded?: FilterBoolEnum;
  pageNumber: number;
  pageSize: number;
  sortColumn: SortAiResponseReviewColumnEnum;
  sortDirection: SortDirectionEnum;
}

export interface AiResponseReviewUpdateInternalModel {
  internalRating: AiResponseReviewRating;
  internalReason: string;
  devResolved: boolean;
}

export interface AiResponseReviewUpdateModel {
  userRating: AiResponseReviewRating;
  userReason?: string;
}

export interface PagedResult<T> {
  items: T[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
}

export interface UtilizationTrendPoint {
  weekStartUtc: string;
  weekEndUtc: string;
  totalCount: number;
  externalCount: number;
  isCurrentPeriod: boolean;
}

export interface ClientWeeklyUsage {
  clientId: number;
  clientName: string;
  weeklyLimit: number;
  responsesUsed?: number;
  isUnlimitedPlan: boolean;
  percentLeftDescription: string;
}

export enum AiChatMessageType {
  Unknown = "unknown",
  UserPrompt = "userPrompt",
  ResponseText = "responseText",
  Table = "table",
  BarChart = "barChart",
  LineChart = "lineChart",
  PieChart = "pieChart",
  System = "system"
}

export interface AiResponseReviewResult {
  responseId: number;
  threadId: string;
  clientId: number;
  clientName: string;
  projectId: number;
  projectName: string;
  userId: number;
  userName: string;
  environment: string;
  prompt: string;
  response: string;
  semanticKernelTemperature?: number;
  searchServiceScoreCutoff?: number;
  searchServiceMaximumDefinitions?: number;
  responseTimeMs: number;
  createdUtc: Date;
  userRating?: AiResponseReviewRating;
  userReason?: string;
  internalRating?: AiResponseReviewRating;
  internalReason?: string;
  internalLastUpdatedUtc?: Date;
  internalUpdatedByUserId?: number;
  internalUpdatedByUserName?: string;
  devResolved: boolean;
  messageType: AiChatMessageType;
  tableDownloaded?: boolean;
  previousSqlLoaded?: boolean;
  chartHeader?: string;
  howIFound?: string;
  chatHistoryReductionPromptVersion?: string;
  requestTypePromptVersion?: string;
  relevanceCheckPromptVersion?: string;
  knowledgeCheckPromptVersion?: string;
  licenseCheckPromptVersion?: string;
  dataSpecialtiesCheckPromptVersion?: string;
  securityCheckPromptVersion?: string;
  cortexPromptVersion?: string;
  cortexDataPromptVersion?: string;
  cortexSuggestionsPromptVersion?: string;
  responseTypePromptVersion?: string;
  reformatPromptVersion?: string;
  explanationPromptVersion?: string;
  limitCheckPromptVersion?: string;
  clarificationPromptVersion?: string;
  semanticViewRouterPromptVersion?: string;
  servicingProviderSchemaPromptVersion?: string;
  contractAggregatesSchemaPromptVersion?: string;
  adequacyResultsSchemaPromptVersion?: string;
  generatorPromptVersion?: string;
  chartHeaderPromptVersion?: string;
  howIFoundPromptVersion?: string;
}
